module.exports = __webpack_public_path__ + "static/media/custom_multiplier_widget_icon.477673c0.svg";